export const floatToDouble = (float: number) => {
    const string = float.toFixed(2);
    return parseFloat(string);
};

export const floatToSingle = (float: number) => {
    const string = float.toFixed(1);
    return parseFloat(string);
};
